import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IDashboardResult } from '../Interfaces/IDashboardResult';
import { GetDashboardNotesRequest } from '../models/dashboard-notes/GetDashboardNotesReuestDto.model';
import { PaginationResponseBase } from '../models/pagination-response-base';
import { PageChangeEvent } from '@progress/kendo-angular-grid';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) { }

  public pageChangeInfo: PageChangeEvent = { skip: 0, take: 10 };
  getDashboardData(buildChartDataUrl: string): Observable<IDashboardResult[]> {
    return this.http.get<IDashboardResult[]>(buildChartDataUrl);
  }
  getDashboardNotesData(baseUrl: string,request: GetDashboardNotesRequest ): Observable<PaginationResponseBase> {
      return this.http.post<PaginationResponseBase>(baseUrl, request);
  }
}
